import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import VR from '../../pages/Content/VR';
import TVPaketi from '../../pages/Content/TVPaketi';
// import FAQ from '../../pages/Content/FAQ';
import ZaNas from '../../pages/Content/ZaNas';
import PravilaZaPolzvane from '../../pages/Content/PravilaZaPolzvane';
// import PolitikaZaPoveritelnost from '../../pages/Content/PolitikaZaPoveritelnost';
import Home from '../../pages/Content/Home';

import StartMigration from '../../pages/Account/StartMigration';
import EmailConfirm from '../../pages/Account/EmailConfirm';
import ConfirmEmail from '../../pages/Account/ConfirmEmail';
import PlanPreview from '../../pages/Account/PlanPreview';
import PlanAdd from '../../pages/Account/PlanAdd';
import Suspended from '../../pages/Account/Suspended';

import AccountData from '../../pages/Account/AccountData';
import AccountSuccess from '../../pages/Account/AccountSuccess';

import ForgottenPass from '../../pages/Account/ForgottenPass';
import ForgottenPassEmail from '../../pages/Account/ForgottenPassEmail';
import ForgottenPassNew from '../../pages/Account/ForgottenPassNew';
import ForgottenPassSuccess from '../../pages/Account/ForgottenPassSuccess';

import ChangePass from '../../pages/Account/ChangePass';
import ChangePassEmail from '../../pages/Account/ChangePassEmail';
import ChangePassNew from '../../pages/Account/ChangePassNew';
import ChangePassSuccess from '../../pages/Account/ChangePassSuccess';

const Routes = () => {
  return (
    <Switch>
      <Route path="/vr" component={VR} />
      <Route path="/televiziia" component={TVPaketi} />
      {/* <Route path="/help" component={FAQ} /> */}
      <Route path="/za-nas" component={ZaNas} />
      <Route path="/pravila-za-polzvane" component={PravilaZaPolzvane} />
      {/* <Route path="/politika-za-poveritelnost" component={PolitikaZaPoveritelnost} /> */}

      <Route path="/start" component={StartMigration} />
      <Route path="/email" component={EmailConfirm} />
      <Route path="/confirm" component={ConfirmEmail} />
      <Route path="/preview" component={PlanPreview} />
      <Route path="/addon" component={PlanAdd} />
      <Route path="/suspended" component={Suspended} />
      <Route path="/account" component={AccountData} />
      <Route path="/finish" component={AccountSuccess} />

      <Route path="/passrecovery" component={ForgottenPass} />
      <Route path="/passrecovery-email" component={ForgottenPassEmail} />
      <Route path="/recoverypass" component={ForgottenPassNew} />
      <Route path="/recoverypass-finish" component={ForgottenPassSuccess} />

      <Route path="/changepass" component={ChangePass} />
      <Route path="/changepass-email" component={ChangePassEmail} />
      <Route path="/passchange" component={ChangePassNew} />
      <Route path="/passchange-finish" component={ChangePassSuccess} />

      <Route path="/" component={Home} />
    </Switch>
  );
};

export default withRouter(Routes);
